// Spor Bahisleri ekranlarının ortak etiketleri.
//
// Liste ve kupon detayı aynı kuponu gösterir; etiketler iki dosyada ayrı ayrı
// yazılsaydı aynı seçime iki ekranda iki farklı ad verilebilirdi. Backend'in
// CSV dışa aktarımı da aynı kümeyi kullanır (admin_router MARKET_LABELS /
// COUPON_STATUS_LABELS) — dosyadaki ad ile ekrandaki ad tutmalıdır.

export const STATUS_LABELS = {
  active: { label: 'Beklemede', cls: 'badge-yellow' },
  won: { label: 'Kazandı', cls: 'badge-green' },
  lost: { label: 'Kaybetti', cls: 'badge-red' },
  cashed_out: { label: 'Cashout', cls: 'badge-yellow' },
};

export const MARKET_LABELS = {
  POINT_SPREAD: 'Handikap', POINT_TOTAL: 'Toplam', MONEYLINE: 'Maç Sonucu',
};

export const PICK_RESULT_CLASS = {
  won: 'text-emerald-400', lost: 'text-rose-400', void: 'text-slate-500',
};

export const PICK_RESULT_LABELS = {
  won: 'Kazandı', lost: 'Kaybetti', void: 'İade', pending: 'Bekliyor',
};

// Kaynak adı kupon bacağında ``provider`` alanındadır; sonuç yolu kaynağa göre
// değiştiği için (bkz. CLAUDE.md "Sonuçlandırma ve cashout") detayda gösterilir.
export const PROVIDER_LABELS = {
  apifootball: 'API-Football',
  sportsbook: 'Sportsbook API',
  oddsapi: 'The Odds API',
};

// Seçim adı UserActivity ve BetCoupons ile aynı mantıkla çözülür: konsensüs
// kaynakları market türünü ve hazır etiketi yazar, API-Football yalnızca 1/X/2.
export const pickLabel = (pick) => (
  `${MARKET_LABELS[pick.market_type] || 'Maç Sonucu'}: ${pick.label || pick.pick_key}`
);

// Yöneticinin verebileceği kararlar. Anahtarlar backend'in ACTIONS kümesiyle
// aynı olmalıdır (services/coupon_settle_admin.py).
//
// ``void`` bahsi iade eder: kupon "kazandı" sayılmaz, parası geri verilmiş
// olarak kapanır. Freebet kuponunda iade edilecek para yoktur — hakkın
// kendisi geri verilir, oyuncu oynayamadığı bir bahis yüzünden hakkını
// kaybetmemelidir.
export const SETTLE_ACTIONS = [
  {
    value: 'won',
    label: 'Kazandır',
    tone: 'text-emerald-300',
    warning: 'Kuponun kendi oranıyla ödeme yapılır ve bakiyeye eklenir.',
  },
  {
    value: 'lost',
    label: 'Kaybettir',
    tone: 'text-rose-300',
    warning: 'Ödeme yapılmaz; kupon kapanır.',
  },
  {
    value: 'void',
    label: 'İade et',
    tone: 'text-amber-300',
    warning: 'Bahis tutarı iade edilir; freebet kuponunda hak geri verilir.',
  },
];

export const settleAction = (value) => (
  SETTLE_ACTIONS.find((item) => item.value === value) || SETTLE_ACTIONS[0]
);

// Sonuçlandırma para hareketi doğurur; kupon uçları bu izinlerden birini
// ister (finance.* eski kurulumlarda çalışmaya devam etsin diye durur).
export const SETTLE_PERMISSION = ['sports.write', 'finance.write'];

// Toplu işlemin sonucunu tek cümlede özetler: "kaçı işlendi, kaçı atlandı".
// Atlanan kupon hata değildir — otomatik sonuçlandırma turu arada kapatmış
// olabilir.
export const settleSummaryText = (result) => {
  const parts = [`${result.settled} kupon sonuçlandırıldı`];
  if (result.skipped) parts.push(`${result.skipped} kupon zaten kapalıydı`);
  if (result.missing) parts.push(`${result.missing} kupon bulunamadı`);
  return `${parts.join(', ')}.`;
};

// Ledger satırının kupondaki rolü. Üç satırın kimliği de kupon numarasından
// türetilir; rolü backend yazar (admin_router.COUPON_LEDGER_KEYS).
export const LEDGER_ROLE_LABELS = {
  bet: 'Bahis (bakiyeden düşülen)',
  win: 'Kupon kazancı',
  cashout: 'Erken kapatma (cashout)',
};
